import { render, staticRenderFns } from "./supplierManagement.vue?vue&type=template&id=e5a33f5a&"
import script from "./supplierManagement.vue?vue&type=script&lang=js&"
export * from "./supplierManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports